
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_k9a1m_3",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_k9a1m_1",
  "refresh": "awsui_refresh_qwoo0_k9a1m_24",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_k9a1m_1",
  "root": "awsui_root_qwoo0_k9a1m_49",
  "interior": "awsui_interior_qwoo0_k9a1m_60",
  "dropdown": "awsui_dropdown_qwoo0_k9a1m_3",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_k9a1m_113",
  "with-limited-width": "awsui_with-limited-width_qwoo0_k9a1m_117",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_k9a1m_120",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_k9a1m_123",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_k9a1m_126",
  "hide-upper-border": "awsui_hide-upper-border_qwoo0_k9a1m_129",
  "open": "awsui_open_qwoo0_k9a1m_136",
  "nowrap": "awsui_nowrap_qwoo0_k9a1m_145",
  "is-empty": "awsui_is-empty_qwoo0_k9a1m_149",
  "dropdown-content": "awsui_dropdown-content_qwoo0_k9a1m_3",
  "ie11-wrapper": "awsui_ie11-wrapper_qwoo0_k9a1m_159",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_k9a1m_163"
};
  